export function getLowestRate<TRate extends { pricing: { price: number } }>(
  rates: readonly TRate[]
): TRate {
  return rates.reduce((lowest, rate) => (rate.pricing.price < lowest.pricing.price ? rate : lowest))
}
